module.exports = __webpack_public_path__ + "assetsclientes/img/slack.5590d0f5.png";